// icon:align-center | Feathericons https://feathericons.com/ | Cole Bemis
import * as React from "react";

function IconAlignCenter(props) {
  return (
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      viewBox="0 0 24 24"
      height="1em"
      width="1em"
      {...props}
    >
      <path d="M18 10H6M21 6H3M21 14H3M18 18H6" />
    </svg>
  );
}

export default IconAlignCenter;
